import { getConfigsMFEFirebase } from '../../../helpers/mfeConfisFirebase'
import { CompanyId } from '../../../models/company-id'
import { CountryId } from '../../../models/country-id'
import { TENANT_ID } from '../tenantId'
import { getDefault } from './defaultConfigs'
import { statusOptions } from '../../../models/filterOptions'

export const getNaturaColombia = () => ({
  ...getDefault(),
  tenantId: TENANT_ID.NATURA_COLOMBIA,
  country: {
    alpha2Code: CountryId.COLOMBIA,
    alpha3Code: 'COL',
    language: 'es',
  },
  company: {
    name: 'NATURA',
    id: CompanyId.NATURA,
    logout: {
      buttonLinkHref: '/login?country=COL&company=NATURA',
      externalLink: false,
    },
  },
  filter: {
    origin: true,
  },
  showEditButtonDetails: true,
  showChangeGroupButton: true,
  canChangeGroup: [statusOptions.suggestedForStart, statusOptions.waitingFirstOrder],
  roles: {
    gn: {
      functionId: 17,
      roleId: 6,
    },
    leader: {
      functionId: 4,
      roleId: 6,
    },
    cb: {
      functionId: 1,
      roleId: 1,
    },
  },
  redirectUrlToLogin: {
    url: async () => getConfigsMFEFirebase('HOSTED_UI_AUTHENTICATION_URL'),
    clientId: async () => getConfigsMFEFirebase('CLIENT_ID_COGNITO'),
  },
})
